import styled, { css } from 'styled-components';
import { ClinicalReviewIcon, TaggedIcon } from 'assets/primaryCare/clinicalReview';
import { Text as P } from 'styles/elements/text';
import { Div, ColumnDiv } from 'styles/elements/div';
import media from 'styles/media';
import { SecondaryButton } from 'styles/elements/buttons';
import ClinicalReviewHelpText, { GroupScoringText } from './clinicalReviewHelpText';
import Radio from './radio';
import { DisplayCheckbox, HiddenCheckbox } from './checkbox';
import SelectOption from './index';

/**
 * Variant of select option that allows rendered buttons to have primary or secondary emphasis within the same select question.
 */
const SelectOptionFlexible = styled(SecondaryButton)`
  margin-top: 0;
  margin-bottom: 0.75em;
  padding: 0.6em 1.2em;
  border-radius: ${props => (props.theme.buttonPrimaryBorderRadius ? props.theme.buttonPrimaryBorderRadius : '20px')};
  font-weight: normal;
  box-sizing: border-box;
  display: flex;
  width: ${props => (props.theme.selectOptionSecondaryWidthSecondary)};
  align-items: center;
  flex-direction: ${props => props.theme.selectOptionFlexDirection};
  min-height: ${props => props.theme.selectOptionMinHeight};
  :focus {
      box-shadow: ${props => props.theme.selectOptionBoxShadowInactiveFocus};
    }
  ${props => (props.selected ? css`
    border: ${props.theme.buttonPrimaryBorderActive};
    background: ${props.theme.buttonPrimaryBackgroundColorActive};
    box-shadow: ${props.theme.selectOptionBoxShadowActive};
    color: ${props.theme.buttonPrimaryFontColorActive};
    :focus {
        box-shadow: ${props.theme.selectOptionBoxShadowFocus};
    }
  ` : css`
    border: ${props.theme.buttonSecondaryBorder};
    background: ${props.theme.buttonSecondaryBackgroundColor};
    color: white;
  `)};
  ${props => (props.isMultiSelect ? `
    background: ${props.selected ? props.theme.checkboxButtonPrimaryBackgroundColorActive : props.theme.checkboxButtonPrimaryBackgroundColor};
    border: ${props.selected ? props.theme.checkboxButtonPrimaryBorderActive : props.theme.checkboxButtonPrimaryBorder};
    color: ${props.selected ? props.theme.checkboxButtonPrimaryFontColorActive : props.theme.fontColorPrimary};
    box-shadow: ${props.selected ? props.theme.checkboxButtonPrimaryBoxShadowActive : 'none'};
  ` : '')};
  ${props => (props.isClinicalReviewMode && props.triageLevel && !props.selected ? props.theme.clinicalReviewStyles[props.triageLevel] : '')};
  ${media.IE9 ? 'width: 100%;' : ''};
  ${HiddenCheckbox}:focus + & {
    box-shadow: ${props => props.theme.checkboxButtonPrimaryBoxShadowFocus};
    outline: none;
  }
`;

const SelectOptionPrimary = styled(SelectOption)`
  width: inherit;
`;

const CheckboxAndTextContainer = styled(Div)`
  flex: ${props => (props.isClinicalReviewMode ? '0 0 50%' : '1 1 0%')};
  text-align: left;
  align-items: center;
  ${media.IE10 ? `
    flex-direction: column;
    overflow: hidden;
  ` : ''};
`;

const Text = styled(P)`
  line-height: 1.6;
  font-family: ${props => props.theme.fontFamily}
  a {
    text-decoration: underline;
    text-underline-position: under;
    color: ${props => props.theme.anchorColor};
  }
`;

const FieldWrapper = styled(ColumnDiv)`
  align-items: center;
  width: ${props => (props.seecondary ? props.theme.selectOptionSecondaryWidthSecondary : props.theme.selectOptionSecondaryWidthPrimary)};
`;

export const GroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

SelectOptionFlexible.Text = Text;
SelectOptionFlexible.Container = CheckboxAndTextContainer;
SelectOptionFlexible.Radio = Radio;
SelectOptionFlexible.DisplayCheckbox = DisplayCheckbox;
SelectOptionFlexible.HiddenCheckbox = HiddenCheckbox;
SelectOptionFlexible.ClinicalReviewIcon = ClinicalReviewIcon;
SelectOptionFlexible.TaggedIcon = TaggedIcon;
SelectOptionFlexible.ClinicalReviewHelpText = ClinicalReviewHelpText;
SelectOptionFlexible.GroupScoringText = GroupScoringText;
SelectOptionFlexible.FieldWrapper = FieldWrapper;
SelectOptionFlexible.GroupWrapper = GroupWrapper;
SelectOptionFlexible.PrimaryOption = SelectOptionPrimary;
SelectOptionFlexible.SecondaryOption = SelectOptionFlexible;

export default SelectOptionFlexible;
